/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolHardWrenchIcon20Solid = forwardRef('ToolHardWrenchIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.691 7.208a1.094 1.094 0 0 1 0-1.547l2.736-2.736c.366-.365.257-.981-.242-1.114a5.645 5.645 0 0 0-6.722 7.484l-5.141 5.14a2.294 2.294 0 1 0 3.245 3.245l5.142-5.141a5.645 5.645 0 0 0 7.481-6.717c-.132-.5-.748-.61-1.114-.244l-2.734 2.734a1.094 1.094 0 0 1-1.547 0L11.69 7.208Z" })));
});
